import React, { useState } from 'react'
import { useAuth } from '../../context/auth';
import "./gamemode.css";

export const Gamemode = () => {

    const { setGameModeFree, setGameModePremium, isPremiumMode, isFreeMode, isTradingMode, togglePremiumGameMode, toggleFreeGameMode } = useAuth()

    const [changeText, setChangeText] = useState('')

    return (
        <div className='cp__gamemode'>
            <span className='d-flex ' style={{
                alignItems: "center",
                justifyContent: "center",
            }}>
                <p style={{ margin: 0, marginRight: "5px", color: "#00FFFF", width: '85px', textAlign: 'right' }}>
                    <strong>
                        {changeText}
                    </strong>
                </p>
                <button
                    onMouseOver={() => {
                        if (isFreeMode) {
                            return setChangeText('CANCEL')
                        }
                        return setChangeText('PLAY')
                    }}
                    onMouseOut={() => setChangeText('')}
                    className={`mode-btn ${isFreeMode && 'selected'}`}
                    onClick={toggleFreeGameMode}
                >
                    Free
                </button>
                <button
                    onMouseOver={() => {
                        if (isPremiumMode || isTradingMode) {
                            return setChangeText('CANCEL')
                        }
                        return setChangeText('PLAY')
                    }}
                    onMouseOut={() => setChangeText('')}
                    className={`mode-btn  ${(isPremiumMode || isTradingMode) && 'selected'}`}
                    onClick={togglePremiumGameMode}
                >
                    Premium
                </button>
            </span>
        </div>
    )
}
